import { GeneralModel, SearchModel, ConsentFormModel } from '../../models';

export enum ActionType {
  SET_LOADING = '[general] set loading',
  CLEAR_LOADING = '[general] clear loading',
  CLEAR_LOADING_MAP = '[general] clear loading map',
  SET_RELATION_UI_ID = '[general] set relation ui id',
  CLEAR_RELATION_MAP = '[general] clear relation map',
  ADD_TOAST_START = '[general] add toast start',
  ADD_TOAST_SUCCESS = '[general] add toast success',
  REMOVE_TOAST = '[general] remove toast',
  SET_MODAL_MAP = '[general] set modal map',
  DESTROY_PRINTER = '[general] destroy printer',
  SET_HIDE_SCROLL = '[general] set hide scroll',
  FETCH_COUNTRY_LIST_START = '[general] fetch country list start',
  FETCH_COUNTRY_LIST_SUCCESS = '[general] fetch country list success',
  FETCH_TIME_ZONE_LIST_START = '[project] fetch time zone list start',
  FETCH_TIME_ZONE_LIST_SUCCESS = '[project] fetch time zone list success',
  FETCH_SEARCH_START = '[general] fetch search start',
  FETCH_SEARCH_SUCCESS = '[general] fetch search success',
  FETCH_SEARCH_MORE_START = '[general] fetch search more start',
  FETCH_SEARCH_MORE_SUCCESS = '[general] fetch search more success',
  FETCH_SEARCH_NEW_START = '[general] fetch search new start',
  FETCH_SEARCH_NEW_SUCCESS = '[general] fetch search new success',
  FETCH_SEARCH_NEW_MORE_START = '[general] fetch search new more start',
  FETCH_SEARCH_NEW_MORE_SUCCESS = '[general] fetch search new more success',
  CLEAR_SEARCH = '[general] clear search',
  FETCH_FEATURE_FLAG_START = '[general] fetch feature flag list start',
  FETCH_FEATURE_FLAG_SUCCESS = '[general] fetch feature flag list success',
  FETCH_CONSENT_FORM_FIELDS_START = '[general] fetch consent form fields start',
  FETCH_CONSENT_FORM_FIELDS_SUCCESS = '[general] fetch consent form fields success',
  SAVE_CONSENT_FORM_FIELDS_BULK_START = '[client] save consent form fields bulk',
  UPDATE_CONSENT_FORM_FIELD_BY_ID_START = '[general] update consent form field by id start',
  UPDATE_CONSENT_FORM_FIELD_BY_ID_SUCCESS = '[general] fetch consent form field by id success',
  DELETE_CONSENT_FORM_FIELD_START = '[general] delete consent form field start',
  FETCH_REGULAR_EXPRESSIONS_START = '[general] fetch regular expressions start',
  FETCH_REGULAR_EXPRESSIONS_SUCCESS = '[general] fetch regular expressions success',
  UPDATE_BILLING_ENGINE_SETTINGS_START = '[general] update billing engine settings start',
  UPDATE_BILLING_ENGINE_SETTINGS_SUCCESS = '[general] update billing engine settings success',
  FETCH_BILLING_ENGINE_SETTINGS_START = '[general] fetch billing engine settings start',
  FETCH_BILLING_ENGINE_SETTINGS_SUCCESS = '[general] fetch billing engine settings success',
}

export const actions = {
  setLoading: (key: string, isLoading: boolean, hasError?: boolean, error?: any, traceId?: string) => ({
    type: ActionType.SET_LOADING,
    payload: { key, isLoading, hasError, error, traceId },
  }),
  clear: (key: string) => ({
    type: ActionType.CLEAR_LOADING,
    payload: { key },
  }),
  clearLoadingMap: () => ({
    type: ActionType.CLEAR_LOADING_MAP,
    payload: {},
  }),
  setRelationUiId: (key: string, value: any, isSecond?: any) => ({
    type: ActionType.SET_RELATION_UI_ID,
    payload: { key, value, isSecond },
  }),
  clearRelationMap: () => ({
    type: ActionType.CLEAR_RELATION_MAP,
    payload: {},
  }),
  addToastStart: (message: string, type: GeneralModel.ToastType) => ({ type: ActionType.ADD_TOAST_START, payload: { message, type } }),
  addToastSuccess: (_id: string, message: string, type: GeneralModel.ToastType) => ({
    type: ActionType.ADD_TOAST_SUCCESS,
    payload: { _id, message, type },
  }),
  removeToast: (_id: string) => ({ type: ActionType.REMOVE_TOAST, payload: { _id } }),
  setModalMap: (list: any[], count: number) => ({ type: ActionType.SET_MODAL_MAP, payload: { list, count } }),
  destroyPrinter: () => ({ type: ActionType.DESTROY_PRINTER, payload: {} }),
  setHideScroll: (hide: boolean) => ({ type: ActionType.SET_HIDE_SCROLL, payload: { hide } }),
  fetchCountryListStart: () => ({ type: ActionType.FETCH_COUNTRY_LIST_START, payload: {} }),
  fetchCountryListSuccess: (list: GeneralModel.INamedEntity[]) => ({ type: ActionType.FETCH_COUNTRY_LIST_SUCCESS, payload: { list } }),
  fetchTimeZoneListStart: () => ({ type: ActionType.FETCH_TIME_ZONE_LIST_START, payload: {} }),
  fetchTimeZoneListSuccess: (list: GeneralModel.INamedEntity[]) => ({ type: ActionType.FETCH_TIME_ZONE_LIST_SUCCESS, payload: { list } }),
  fetchSearchStart: (search: SearchModel.ISearchParams) => ({ type: ActionType.FETCH_SEARCH_START, payload: { search } }),
  fetchSearchSuccess: (list: GeneralModel.IPagination<SearchModel.IResponse | SearchModel.IWorker>) => ({
    type: ActionType.FETCH_SEARCH_SUCCESS,
    payload: { list },
  }),
  fetchSearchMoreStart: (search: SearchModel.ISearchParams) => ({ type: ActionType.FETCH_SEARCH_MORE_START, payload: { search } }),
  fetchSearchMoreSuccess: (list: GeneralModel.IPagination<SearchModel.IResponse | SearchModel.IWorker>) => ({
    type: ActionType.FETCH_SEARCH_MORE_SUCCESS,
    payload: { list },
  }),

  fetchSearchNewStart: (search: SearchModel.ISearchParams) => ({ type: ActionType.FETCH_SEARCH_NEW_START, payload: { search } }),
  fetchSearchNewSuccess: (list: GeneralModel.IPagination<SearchModel.IResponse | SearchModel.IWorker>, searchType: SearchModel.SearchType) => ({
    type: ActionType.FETCH_SEARCH_NEW_SUCCESS,
    payload: { list, searchType },
  }),
  fetchSearchNewMoreStart: (search: SearchModel.ISearchParams) => ({ type: ActionType.FETCH_SEARCH_NEW_MORE_START, payload: { search } }),
  fetchSearchNewMoreSuccess: (list: GeneralModel.IPagination<SearchModel.IResponse | SearchModel.IWorker>) => ({
    type: ActionType.FETCH_SEARCH_NEW_MORE_SUCCESS,
    payload: { list },
  }),

  clearSearch: () => ({ type: ActionType.CLEAR_SEARCH, payload: {} }),
  fetchFeatureListStart: () => ({ type: ActionType.FETCH_FEATURE_FLAG_START, payload: {} }),
  fetchFeatureListSuccess: (list: any) => ({ type: ActionType.FETCH_FEATURE_FLAG_SUCCESS, payload: { list } }),
  fetchConsentFormFieldsStart: (consentFormFieldType: number, companyIds?: string[], includeListItems?: boolean, includeUsageCount?: boolean) => ({
    type: ActionType.FETCH_CONSENT_FORM_FIELDS_START,
    payload: { consentFormFieldType, companyIds, includeListItems, includeUsageCount },
  }),
  fetchConsentFormFieldsSuccess: (data: ConsentFormModel.IConsentFormField[], consentFormFieldType: number) => ({
    type: ActionType.FETCH_CONSENT_FORM_FIELDS_SUCCESS,
    payload: { data, consentFormFieldType },
  }),
  fetchRegularExpressionsStart: () => ({
    type: ActionType.FETCH_REGULAR_EXPRESSIONS_START,
    payload: {},
  }),
  fetchRegularExpressionsSuccess: (data: any) => ({
    type: ActionType.FETCH_REGULAR_EXPRESSIONS_SUCCESS,
    payload: data,
  }),
  saveConsentFormFieldsBulkStart: (payload: any, consentFormFieldType: number, companyIds: string[]) => ({
    type: ActionType.SAVE_CONSENT_FORM_FIELDS_BULK_START,
    payload: {
      consentFormFieldType,
      companyIds,
      payload,
    },
  }),
  updateConsentFormFieldByIdStart: (id: string, payload: any, consentFormFieldType: number, companyIds: string[]) => ({
    type: ActionType.UPDATE_CONSENT_FORM_FIELD_BY_ID_START,
    payload: {
      consentFormFieldType,
      companyIds,
      payload,
      id,
    },
  }),
  deleteConsentFormFieldStart: (consentFormFieldType: number, companyIds: string[], id: string) => ({
    type: ActionType.DELETE_CONSENT_FORM_FIELD_START,
    payload: {
      id,
      consentFormFieldType,
      companyIds,
    },
  }),
  updateBillingEngineSettingsStart: (projectId: string, data: any) => ({
    type: ActionType.UPDATE_BILLING_ENGINE_SETTINGS_START,
    payload: {
      id: projectId,
      payload: data,
    },
  }),
  fetchBillingEngineSettingsStart: (projectId: string) => ({
    type: ActionType.FETCH_BILLING_ENGINE_SETTINGS_START,
    payload: {
      id: projectId,
    },
  }),
  fetchBillingEngineSettingsSuccess: (data: any) => ({
    type: ActionType.FETCH_BILLING_ENGINE_SETTINGS_SUCCESS,
    payload: data,
  }),
};
